(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Chip", [], factory);
	else if(typeof exports === 'object')
		exports["Chip"] = factory();
	else
		root["Chip"] = factory();
})(window, function() {
return 